// Library
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import History from '@material-ui/icons/History';

export const columns = [
    { title: "Id", field: "id", hidden: true },
    {
        title: "Marca",
        field: "brand",
        customSort: (a, b) => {
            const sortTextA = a.brand + a.model;
            const sortTextB = b.brand + b.model;
            return sortTextA > sortTextB ? 1 : -1;
        }
    },
    { title: "Modelo", field: "model" },
    { title: "Patente", field: "patent" },
    { title: "Chasis/Motor", field: "chassis_motor" },
    { title: "Año", field: "year", type: "numeric" },
    { title: "Activo", field: "active", hidden: true },
    { title: "¿Tiene alertas?", field: "hasActiveAlerts", hidden: true, defaultSort: 'desc' },
];

export const actions = (history) => [
    {
        icon: LibraryBooksIcon,
        tooltip: "Ver documentos",
        onClick: (event, vehicle) => {
            history.push(`/vehicles/${vehicle.id}/documents`);
        },
    },
    {
        icon: History,
        tooltip: "Ver Incidencias",
        onClick: (event, vehicle) => {
            history.push(`/vehicles/${vehicle.id}/incidences`);
        },
    }];

export const requiredFields = ["brand", "model", "patent", "chassis_motor", "year"]

export const deleteText = "Se borraran todos los requerimientos asociados"



// WEBPACK FOOTER //
// ./src/Containers/Vehicles/VehicleReusableConstants.js